<footer>
    <div class="container-fluid">
        <p class="text-center">© 2016 - {{currentYear}} Daton All rights reserved.  <a href="https://sarasanalytics.com/privacy" target="_blank">Privacy</a>  and  <a href="https://sarasanalytics.com/t_c.html" target="_blank">Terms</a></p>
    </div>
    
</footer>


